import dayjs from 'dayjs';
import 'dayjs/locale/it';

dayjs.locale('it');

/**
 * Escapes CSV values that contain commas, quotes, or newlines
 * @param {any} value - The value to escape
 * @returns {string} - Escaped CSV value
 */
const escapeCSV = (value) => {
  if (value === null || value === undefined) return '';
  const stringValue = String(value);
  if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

/**
 * Formats a date to 'DD-MMM-YY' format (e.g., '25-lug-25')
 * @param {Date|string} date - The date to format
 * @returns {string} - Formatted date or empty string
 */
const formatDate = (date) => {
  if (!date) return '';
  return dayjs(date).locale('it').format('DD-MMM-YY').toLowerCase();
};

/**
 * Exports finance data to CSV file
 * @param {Array} data - Array of finance objects
 */
export const exportFinanceToCSV = (data) => {
  if (!data || data.length === 0) {
    return;
  }

  // CSV Headers
  const headers = [
    'Tipo',
    'Nome',
    'Data',
    'Metodo',
    'Importo',
    'Nome Utente',
    'Cognome Utente',
    'Email Utente',
    'Stripe ID',
    'Registrato Da (Nome Cognome Ruolo)'
  ];

  // Convert data to CSV format
  const csvRows = data.map((row) => {
    const registeredBy = row.registeredBy
      ? `${row.registeredBy.name} ${row.registeredBy.surname} (${row.registeredBy.roles?.[0] || 'member'})`
      : 'N/A';

    return [
      row.type || '',
      row.name || '',
      formatDate(row.createdAt),
      row.method || '',
      `€${row.amount || 0}`,
      row.user?.name || '',
      row.user?.surname || '',
      row.user?.email || '',
      row.stripeId || '',
      registeredBy
    ];
  });

  // Create CSV content
  const csvContent = [
    headers.map(escapeCSV).join(','),
    ...csvRows.map(row => row.map(escapeCSV).join(','))
  ].join('\n');

  // Create blob and download file
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `finanze_${dayjs().format('DD-MMM-YY')}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

